<template>
    <div>
        <div class="container">
            <div class="crumbs">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>协议信息</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="container">
                <el-form :inline="true" :model="query" ref="query">
                    <el-form-item  label="协议选择" prop="agreementSelect" >
                        <el-select v-model="query.agreementSelect" placeholder="运费规则设置">
                            <el-option :value="1" label="协议名称1"></el-option>
                            <el-option :value="2" label="协议名称2"></el-option>
                            <el-option :value="3" label="协议名称3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
       <div class="container">
           <div class="crumbs">
               <el-breadcrumb separator="/">
                   <el-breadcrumb-item>协议商品</el-breadcrumb-item>
               </el-breadcrumb>

               <el-divider></el-divider>
               <div style="margin-bottom: 20px">
                   <el-button type="primary" @click="handleProductAdd">新增</el-button>
               </div>
               <TableList
                       :table-label="tableLabel"
                       :table-option="tableOption"
                       :loading="loading"
               ></TableList>
               <div class="pagination">
                   <el-pagination
                            background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                           layout="total, sizes, prev, pager, next, jumper"
                           :current-page="productTagPage.currentPage"
                           :page-size="productTagPage.pageSize"
                           :total="productTagPage.pageTotal"
                           :small="true"
                   >
                   </el-pagination>
               </div>
           </div>
       </div>
        <ProductSelectDialog :visible="productSelectDialogShow" @close="closeProductDialog"></ProductSelectDialog>
    </div>
</template>

<script>
    import TableList from '../../../../components/common/table-list'
    import ProductSelectDialog from '../../components/product/productManage/productSelectDialog'
    export default {
        name: "agreementAdd",
        components: {
            TableList,
            ProductSelectDialog,
        },
        props: {},
        data() {
            return {
                tableLabel: [
                    { label: 'id', param: 'id',  align: 'center', type:'selection',fixed:'left'},
                    { label: '单品图片', param: 'ruleName', align: 'center' ,slot:'ruleName'},
                    { label: '单品名称', param: 'useStatus', align: 'center' },
                    { label: '单品编号', param: 'useStatus', align: 'center' },
                    { label: '品牌', param: 'useStatus', align: 'center' },
                    { label: '所属分类', param: 'useStatus', align: 'center' },
                    { label: '计量单位', param: 'useStatus', align: 'center' },
                    { label: '协议价', param: 'useStatus', align: 'center' },
                    { label: '市场价', param: 'useStatus', align: 'center' },
                ],
                tableOption: {
                    label: '操作',
                    width: '100',
                    fixed:'right',
                    permission:'0',
                    options: [
                        { label: '编辑', type: 'primary', icon: 'el-icon-view', methods: 'preview' },
                    ]
                },
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                loading:false,
                productSelectDialogShow:false,
                query:{
                    agreementSelect:''
                }
            }
        },
        computed: {},
        created() {
        },
        methods: {
            handleProductAdd(){
                this.productSelectDialogShow = true
            },
            handleSizeChange(){},
            handleCurrentChange(){},
            closeProductDialog(){
                this.productSelectDialogShow = false
            }
        }

    }
</script>

<style scoped>

</style>
